<template>
  <div class="flex items-start justify-start gap-2">
    <template v-if="type == 'el-input-number'">
      <div class="flex flex-col gap-1">
        <el-input-number
          :class="inputClass"
          style="width: 115px"
          v-model="val"
          :step="1"
          size="mini"
          :min="1"
          @input="onQuantityChanges" @change="onQuantityChanges"
      ></el-input-number>
        <slot name="qtyLabel"></slot>
      </div>
    </template>
    <template v-else>
      <el-input type="number" v-model="val" :min="1"
                @input="onQuantityChanges" @change="onQuantityChanges"></el-input>
    </template>
    <el-popover :visible="visible" :width="260">
      <div :dir="$ctx.locale == 'en'? 'ltr': 'rtl'" class="flex flex-col gap-4">
        <div class="flex flex-col gap-1">
          <div>{{ t('chooseAPack') }}</div>
          <el-select v-model="selectedPack" filterable class="w-full"
                     @change="onSelectedPackChange" placeholder="">
            <el-option v-for="(ip, j) in item.itemPacks" :key="j"
                       :disabled="ip.disabled || item.isSerialized"
                       :label="$ctx.locale == 'en' ? ip.pack.enName: ip.pack.arName"
                       :value="ip.id">
            </el-option>
          </el-select>
        </div>
        <div class="flex flex-col gap-1">
          <div>{{ t('qty') }}</div>
          <el-input type="number" v-model="packQuantity" :min="1"></el-input>
        </div>
        <div style="text-align: right; margin: 0">
          <el-button v-if="selectedPack && usePackQuantity" text
                     @click="makeSingle" type="warning">{{ t('single') }}
          </el-button>
          <el-button text @click="visible = false">{{ t('cancel') }}</el-button>
          <el-button :disabled="!selectedPack" type="primary" @click="confirm">
            {{ t('ok') }}
          </el-button>
        </div>
      </div>

      <template #reference>
        <div class="flex flex-col mt-1">
          <font-awesome-icon v-if="item?.itemPacks?.length"
                             :class="{'text-blue-500': selectedPack}"
                             class="text-lg cursor-pointer outline-none"
                             icon="boxes"
                             @click="visible = !visible"/>
          <slot name="label"></slot>
        </div>
      </template>
    </el-popover>
  </div>
</template>
<script setup lang="ts">

import {defineEmits, defineProps, onBeforeMount, ref} from "vue";
import {watch} from "vue-demi";
import {useI18n} from "vue-i18n";
import ItemPack from "@/models/inventory/ItemPack";

const props = defineProps(['modelValue', 'item', 'type', 'inputClass', 'usePackQuantity', 'packInfo', 'max'])
const emit = defineEmits(['update:modelValue', 'onPack'])


const messages = {
  en: {
    chooseAPack: 'Choose a pack',
    qty: 'Qty',
    ok: 'Ok',
    cancel: 'Cancel',
    single: 'Single'
  },
  ar: {
    chooseAPack: 'اختر حزمة',
    qty: 'الكمية',
    ok: 'موافق',
    cancel: 'الغاء',
    single: 'مفرد'
  }
}
const {t} = useI18n({messages, useScope: 'global'})

const val = ref()
const maxVal = ref<Number|undefined>();
const packInfoVal = ref<any | null>(null)
const visible = ref(false)

const selectedPack = ref<ItemPack | null>()
const packQuantity = ref(1)

onBeforeMount(() => {
  maxVal.value = props.max
  val.value = props.modelValue;
  packInfoVal.value = props.packInfo;
  loadPackInfo()
})

watch(() => props.packInfo, (newVal) => {
  packInfoVal.value = newVal
  loadPackInfo()
}, {deep: true});

function loadPackInfo() {
  if (packInfoVal.value) {
    let found = false;
    for (const ip of props.item.itemPacks) {
      if (ip.id == packInfoVal.value.itemPackID) {
        selectedPack.value = ip.id;
        found = true;
      }
    }

    if (!found) {
      selectedPack.value = null;
    }

    packQuantity.value = packInfoVal.value.soldQuantity;
  } else {
    selectedPack.value = null;
  }
}

watch(() => props.modelValue, (newValue) => {
  val.value = newValue;
}, {deep: true})

watch(() => val.value, (newValue) => {
  emit('update:modelValue', newValue)
}, {deep: true})

function onSelectedPackChange(e: ItemPack) {
  console.log(e)
}

function confirm() {
  visible.value = false;

  let selectedPackObject = null;
  for (const ip of props.item.itemPacks) {
    if (ip.id == selectedPack.value) {
      selectedPackObject = ip;
    }
  }

  if (props.usePackQuantity) {
    val.value = Number.parseInt(packQuantity.value);
    emit('onPack', {
      packID: selectedPackObject?.packID,
      packQuantity: selectedPackObject?.qty,
      soldQuantity: val.value,
      itemPackID: selectedPackObject?.id,
      itemPack: selectedPackObject,
      salePriceAmount: selectedPackObject?.salePriceAmount
    })
    return;
  }
  val.value = packQuantity.value * selectedPackObject?.qty!;
  emit('onPack', {
    packID: selectedPackObject?.packID,
    packQuantity: selectedPackObject?.qty,
    soldQuantity: packQuantity.value,
    itemPackID: selectedPackObject?.id,
    itemPack: selectedPackObject,
    salePriceAmount: selectedPackObject?.salePriceAmount
  })
}

function makeSingle() {
  let selectedPackObject = null;
  for (const ip of props.item.itemPacks) {
    if (ip.id == selectedPack.value) {
      selectedPackObject = ip;
    }
  }

  val.value = packQuantity.value * selectedPackObject?.qty!;
  selectedPack.value = undefined;
  packQuantity.value = 1;
  emit('onPack', null);
  visible.value = false;
}

function onQuantityChanges(e: any) {
  if (e > (maxVal.value || Infinity)) {
    val.value = Number(maxVal.value);
  }
}
</script>
